// import * as React from "react";
import React, { useState, useEffect } from "react";
import axios from "axios";

import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";
// import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
// import Button from "@mui/material/Button";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

import DefaultFooter from "examples/Footers/DefaultFooter";
// import SignIn from "layouts/pages/authentication/sign-in";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import footerRoutes from "footer.routes";
import routes from "routes";
import bgImage from "assets/images/bg-db.jpg";

function VulnerabilityDb() {
  const [vulnerabilities, setVulnerabilities] = useState([]);
  const [phase, setPhase] = useState("");
  const [attribute, setAttribute] = useState("");
  const [effect, setEffect] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 15 });

  useEffect(() => {
    const url = `/api/vulnerability-db?approval_status=approved&phase=${phase}&attribute=${attribute}&effect=${effect}&startDate=${startDate}&endDate=${endDate}`;

    axios
      .get(url)
      .then((response) => {
        console.log("Response: ", response.data);
        return response.data;
      })
      .then((data) => {
        console.log("JSON response:", data);
        if (Array.isArray(data)) {
          const formattedRows = data.map((vul) => {
            let formattedAttributes = vul.attributes;

            if (typeof formattedAttributes === "string") {
              formattedAttributes = formattedAttributes
                .replace(/[{}"]/g, "")
                .split(",")
                .map((attr) => attr.trim())
                .join(", ");
            } else if (Array.isArray(formattedAttributes)) {
              formattedAttributes = formattedAttributes.join(", ");
            }

            return {
              id: vul.id,
              // date_added: vul.date_added?.slice(0, 10),
              title: vul.title,
              artifact: vul.artifacttype,
              phase: vul.phase,
              effects: vul.effectname,
              attributes: formattedAttributes,
            };
          });
          setVulnerabilities(formattedRows);
        } else {
          console.error("Fetched data is not an array:", data);
          setVulnerabilities([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching vulnerabilities:", error);
      });
  }, [phase, attribute, effect, startDate, endDate]);

  const clearFilters = () => {
    setPhase("");
    setAttribute("");
    setEffect("");
    setStartDate("");
    setEndDate("");
  };

  const columns = [
    { field: "id", headerName: "ID", type: "number", width: 70 },
    // { field: "date_added", headerName: "Date Added", width: 130 },
    {
      field: "title",
      headerName: "Title",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      width: 160,
      renderCell: (params) => (
        <a
          href={`/vulnerability-db/id/${params.row.id}`}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          {params.value}
        </a>
      ),
    },
    {
      field: "artifact",
      headerName: "Artifact",
      width: 130,
      renderCell: (params) => (
        <a
          href={`/vulnerability-db/id/${params.row.id}`}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          {params.value}
        </a>
      ),
    },
    {
      field: "phase",
      headerName: "Phase",
      width: 130,
      renderCell: (params) => (
        <a
          href={`/vulnerability-db/id/${params.row.id}`}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          {params.value}
        </a>
      ),
    },
    {
      field: "effects",
      headerName: "Effects",
      width: 135,
      renderCell: (params) => (
        <a
          href={`/vulnerability-db/id/${params.row.id}`}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          {params.value}
        </a>
      ),
    },
    {
      field: "attributes",
      headerName: "Attributes",
      width: 130,
      renderCell: (params) => (
        <a
          href={`/vulnerability-db/id/${params.row.id}`}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          {params.value}
        </a>
      ),
    },
  ];

  return (
    <>
      <DefaultNavbar routes={routes} transparent={false} relative light={false} />
      <MKBox
        minHeight="60vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <MKTypography
              variant="h2"
              color="white"
              mt={10}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Vulnerability Database
            </MKTypography>
            <MKTypography variant="body1" color="white" opacity={0.8} mt={1} mb={3}>
              Welcome to the AIVT Vulnerability Database—your ultimate destination for navigating
              the complex landscape of AI vulnerabilities. This comprehensive repository is
              meticulously curated to empower developers, researchers, and security professionals
              with the knowledge they need to identify, assess, and mitigate risks in AI and ML
              systems. Whether you&apos;re looking to safeguard your technology or contribute to the
              collective understanding of AI security, our database is your key resource for staying
              ahead of emerging threats and ensuring the future of AI remains secure and reliable.
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Container sx={{ mt: 4 }}>
        <Grid container justifyContent="space-between" sx={{ mb: 2 }}>
          <Grid sx={{ display: "flex", gap: 2, flexWrap: "nowrap", width: "100%" }}>
            <FormControl fullWidth>
              <InputLabel>Phase</InputLabel>
              <Select
                value={phase}
                onChange={(e) => setPhase(e.target.value)}
                label="Phase"
                sx={{ padding: 1.5 }}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="Development">Development</MenuItem>
                <MenuItem value="Training">Training</MenuItem>
                <MenuItem value="Deployment and Use">Deployment and Use</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel>Attribute</InputLabel>
              <Select
                value={attribute}
                onChange={(e) => setAttribute(e.target.value)}
                label="Attribute"
                sx={{ padding: 1.5 }}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="Accuracy">Accuracy</MenuItem>
                <MenuItem value="Fairness">Fairness</MenuItem>
                <MenuItem value="Privacy">Privacy</MenuItem>
                <MenuItem value="Reliability">Reliability</MenuItem>
                <MenuItem value="Resiliency">Resiliency</MenuItem>
                <MenuItem value="Robustness">Robustness</MenuItem>
                <MenuItem value="Safety">Safety</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel>Effect</InputLabel>
              <Select
                value={effect}
                onChange={(e) => setEffect(e.target.value)}
                label="Effect"
                sx={{ padding: 1.5 }}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="0: Correct functioning">0: Correct functioning</MenuItem>
                <MenuItem value="1: Reduced functioning">1: Reduced functioning</MenuItem>
                <MenuItem value="2: No actions">2: No actions</MenuItem>
                <MenuItem value="3: Chaotic">3: Chaotic</MenuItem>
                <MenuItem value="4: Directed actions">4: Directed actions</MenuItem>
                <MenuItem value="5: Random actions OoB">5: Random actions OoB</MenuItem>
                <MenuItem value="6: Directed actions OoB">6: Directed actions OoB</MenuItem>
              </Select>
            </FormControl>
            <TextField
              label="Start Date"
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
            <TextField
              label="End Date"
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
            <MKButton
              onClick={clearFilters}
              variant="contained"
              color="primary"
              style={{ cursor: "pointer" }}
            >
              Clear
            </MKButton>
          </Grid>
        </Grid>
        <Paper sx={{ height: 800, width: "100%" }}>
          <DataGrid
            rows={vulnerabilities}
            columns={columns}
            // pagination
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[5, 10]}
            // checkboxSelection
            sx={{ border: 0 }}
          />
        </Paper>
        <Stack spacing={2} alignItems="center" sx={{ mt: 2, mb: 4 }}>
          <Pagination // number of pages: total rows / rows per page
            count={Math.max(1, Math.ceil(vulnerabilities.length / paginationModel.pageSize))}
            page={paginationModel.page + 1}
            onChange={(e, value) =>
              setPaginationModel((prev) => ({
                ...prev,
                page: value - 1,
              }))
            }
          />{" "}
        </Stack>
      </Container>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default VulnerabilityDb;
